import { APIError } from "../../../common_modules/model/APIError";
export interface State {
    authenticating?: boolean,
    authenticationError?: APIError
}

export const initialState: State = {authenticating:false};